import AppRoutes from 'constants/appRoutes'
import { Redirect } from 'react-router-dom'

const RedirectLogin = () => <Redirect to={AppRoutes.LOGIN_ROUTE} />

RedirectLogin.displayName = 'RedirectLogin'

export default RedirectLogin
